import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=3e38a26b&scoped=true&lang=pug&"
import script from "./NotificationsView.vue?vue&type=script&lang=ts&"
export * from "./NotificationsView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=3e38a26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38a26b",
  null
  
)

export default component.exports